/**
 * Implements a news header which display news messages
 */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import UpdatesBlock from '../Info/CoinNews';
import LogsBlock from './LogsBlock';
import NewsBlock from './NewsBlock';
import Text from '../../atoms/Text';
import useLastSeen from './useLastSeen';
import Image from '../../atoms/Image';
import { IStore } from '../../reducers';
import { INewsItem } from '../../reducers/news';
import notifIcon from '../../assets/images/notification.svg';
import close from '../../assets/images/close.svg';
import notice from '../../assets/images/notice.svg';
import './styles.scss';

const useSlider = (items: INewsItem[]) => {
  const [index, setIndex] = useState(0);

  const onClick = (index: number) => {
    setIndex(index);
  };

  return {
    index,
    onClick,
  };
};

const modes = [
  {
    name: 'Logs',
    amount: undefined,
  },
  {
    name: 'News',
    amount: undefined,
  },
  {
    name: 'Updates',
    amount: 10,
  },
];

const News = () => {
  const { items, loading } = useSelector((state: IStore) => state.news);
  const [visible, setvisible] = useState<boolean>(false);
  const [mode, setMode] = useState('News');
  const { index, onClick: onSliderClick } = useSlider(items);
  const { lastSeen, updateLastSeen } = useLastSeen(items);

  const onStopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    e.stopPropagation();

  if (loading) {
    return null;
  }

  const onHide = (e: React.SyntheticEvent<any>) => {
    setvisible(!visible);
    updateLastSeen();
  };

  const last_seen_id = items[0] && items[0].id;

  return (
    <>
      {visible && <div className='news__backdrop' onClick={onHide} />}
      <div className='news' onClick={items.length > 0 ? onHide : undefined}>
        <div
          className={`news__icon icon-notification ${
            visible ? 'news__icon--active' : ''
          }`}
        >
          {lastSeen !== last_seen_id && (
            <Image size='xxs' src={notice} className='news__icon__notice' />
          )}
        </div>
        {visible && (
          <div className='notifications'>
            <div className='news_block' onClick={onStopPropagation}>
              <div className='row'>
                <div className='row'>
                  <div className='price_alert__create__image'>
                    <Image size='s' src={notifIcon} />
                  </div>
                  <Text size={14} className='text--grey-200'>
                    Notifications
                  </Text>
                </div>
                <Image size='s' src={close} onClick={onHide} />
              </div>
              {/* Mode */}
              <div className='modeSelector'>
                {modes.map((item) => (
                  <div
                    key={item.name}
                    className={`modeSelector__item text--weight-600 ${
                      mode === item.name
                        ? 'modeSelector__item--active text--grey-200'
                        : 'text--grey-600'
                    }`}
                    onClick={() => setMode(item.name)}
                  >
                    <Text size={12}>{item.name}</Text>
                  </div>
                ))}
              </div>
              {mode === 'Logs' && <LogsBlock />}
              {mode === 'News' && (
                <NewsBlock
                  onClick={onSliderClick}
                  index={index}
                  items={items}
                />
              )}
              {mode === 'Updates' && <UpdatesBlock slug='KTN' />}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default News;
